import { money } from "../api.js";

// Сума з копійками окремим елементом: «12 345,<span>67</span>». Текст той самий, що й money(v) (uk-UA, 2 знаки),
// тож для читача екрана й копіювання нічого не змінюється; вигляд minimal робить копійки дрібнішими (.money-frac).
// Без значення — порожньо, як money(null). text — уже відформатована сума (kopUi для копійок BigInt) — ділиться так само
export default function Money({ value, text, className = "" }) {
  const s = text ?? money(value);
  const i = s.lastIndexOf(",");
  if (i < 0) return <span className={`money${className ? ` ${className}` : ""}`}>{s}</span>;
  return <span className={`money${className ? ` ${className}` : ""}`}>{s.slice(0, i)}<span className="money-frac">{s.slice(i)}</span></span>;
}
